module.exports = __webpack_public_path__ + "static/media/06.02b0241d.png";